import { goRequest as request } from '../utils/httpClientTs';
import {
  TrainingListRequest,
  TrainingDetailRequest,
  TrainingCompleteRequest,
  TrainingCreateRequest,
  TrainingTopicsResponse,
  TrainingCategoriesResponse,
  TrainingRolesResponse,
  TrainingGroupsResponse,
  TrainingsInGroupResponse,
  TrainingListResponse,
  TrainingDetailResponse,
  TrainingCompleteResponse,
  TrainingCreateResponse,
} from '../types/training';

export const getTrainingTopics = (): Promise<TrainingTopicsResponse> =>
  request({
    url: '/training/topic',
    method: 'GET',
  });

export const getTrainingCategory = (): Promise<TrainingCategoriesResponse> =>
  request({
    url: '/training/category',
    method: 'GET',
  });

export const getTrainingRoles = (): Promise<TrainingRolesResponse> =>
  request({
    url: '/training/role',
    method: 'GET',
  });

export const getTrainingGroups = (): Promise<TrainingGroupsResponse> =>
  request({
    url: '/training/group',
    method: 'GET',
  });

export const getTrainingsInGroup = (
  groupSelected: string
): Promise<TrainingsInGroupResponse> =>
  request({
    url: `/training/group/${groupSelected}`,
    method: 'GET',
  });

export const getTrainingList = (
  data: TrainingListRequest
): Promise<TrainingListResponse> => {
  let url = '/training/list?page_size=100&page=1';

  if (data.search) {
    url += `&search=${data.search}`;
  }

  if (data.categories?.length) {
    url += `&categories=${data.categories.join(',')}`;
  }

  if (data.topics?.length) {
    url += `&topics=${data.topics.join(',')}`;
  }

  return request({
    url: url,
    method: 'GET',
  });
};

export const getTrainingDetail = (
  data: TrainingDetailRequest
): Promise<TrainingDetailResponse> =>
  request({
    url: `/training/${data.id}`,
    method: 'GET',
  });

export const completeTraining = (
  data: TrainingCompleteRequest
): Promise<TrainingCompleteResponse> =>
  request({
    url: `/training/${data.id}/complete`,
    method: 'POST',
  });

export const submitTrainingAPI = (
  data: TrainingCreateRequest
): Promise<TrainingCreateResponse> =>
  request({
    url: '/training',
    method: 'POST',
    data: data,
  });

export const updateTraining = (
  id: string,
  data: TrainingCreateRequest
): Promise<void> =>
  request({
    url: `/training/${id}`,
    method: 'PATCH',
    data: data,
  });
